var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 55,
    viewBox: "0 0 87 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4805 15.7422C49.3287 15.7422 44.7247 18.4132 44.7247 23.3481C44.7247 29.0077 52.89 29.3985 52.89 32.2417C52.89 33.4388 51.5184 34.5104 49.176 34.5104C45.8514 34.5104 43.3667 33.0131 43.3667 33.0131L42.3035 37.993C42.3035 37.993 45.1659 39.2578 48.9661 39.2578C54.5988 39.2578 59.0309 36.4557 59.0309 31.4362C59.0309 25.4561 50.8317 25.0768 50.8317 22.4379C50.8317 21.5 51.9576 20.4725 54.2934 20.4725C56.9289 20.4725 59.0791 21.5615 59.0791 21.5615L60.1196 16.7518C60.1196 16.7518 57.78 15.7422 54.4805 15.7422ZM7.34606 16.1052L7.22131 16.8312C7.22131 16.8312 9.38871 17.228 11.3408 18.0195C13.8543 18.927 14.0333 19.4555 14.4567 21.0964L19.0694 38.8835H25.2529L34.779 16.1052H28.6098L22.4887 31.5922L19.9909 18.4647C19.7618 16.9623 18.6015 16.1052 17.1813 16.1052H7.34606ZM37.2597 16.1052L32.4202 38.8835H38.3031L43.1257 16.1052H37.2597ZM70.071 16.1052C68.6524 16.1052 67.9008 16.865 67.3493 18.1924L58.7304 38.8835H64.8997L66.0933 35.435H73.6093L74.3351 38.8835H79.7786L75.0297 16.1052H70.071ZM70.8733 22.2591L72.7021 30.8067H67.8029L70.8733 22.2591Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.a2cc524fa073c69ba01117f4f45be519.svg";
export { ForwardRef as ReactComponent };